import React from 'react';
import AlertTriangleIcon from '../icons/AlertTriangleIcon'; // Assuming you created this

const AlertMessage = ({ message, type = "info-custom" }) => {
    return (
        <div className={`alert alert-${type} d-flex align-items-start`} role="alert">
            <AlertTriangleIcon className="me-2 flex-shrink-0" style={{ width: '30px', height: '30px' }} />
            <span>{message}</span>
        </div>
    );
};

export default AlertMessage;